<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'manufacturers.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: {
                    name: ''
                },
                validation: {
                    name: ''
                }
            };
        },
        methods: {
            onSubmit(_ev) {
                var self = this;
                var valid = true;
                self.validation.name = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');

                    const response = self.$store.dispatch('manufacturers/add', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Fabricante cadastrado com sucesso!");
                        self.$router.push({'name': 'manufacturers.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            }
        }
    };
</script>